import React from 'react'

const VerticalDivider = ({ space }) => {
  return <div {...{ style: { height: space, width: '100%' } }} />
}

export default VerticalDivider
